import { z } from 'zod';

export const Range = z.object({
	min: z.number(),
	max: z.number(),
});

export type Range = z.infer<typeof Range>;
